module.exports = __webpack_public_path__ + "img/26.d15d6d6b.jpg";